export const range = (end: number, start = 0, step = 1) => {
    const range = []

    for (let i = start; i < end; i += step) {
        range.push(i)
    }

    return range
}
